import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../mock';

const Footer = () => {
  const handleEmailClick = () => {
    window.location.href = `mailto:${businessInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${businessInfo.phone}`;
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src={businessInfo.logo}
              alt={businessInfo.name} 
              className="h-12 w-auto filter brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Professional custom shutters for homes and businesses. Quality craftsmanship 
              with attention to detail for over a decade.
            </p>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li className="hover:text-white transition-colors cursor-pointer">Roller Shutters</li>
              <li className="hover:text-white transition-colors cursor-pointer">Security Doors</li>
              <li className="hover:text-white transition-colors cursor-pointer">Repairs & Maintenance</li>
              <li className="hover:text-white transition-colors cursor-pointer">Custom Fitting & Colours</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Us</h3>
            <div className="space-y-3">
              <div 
                className="flex items-center space-x-3 text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                onClick={handlePhoneClick}
              >
                <Phone className="h-4 w-4" />
                <span>{businessInfo.phone}</span>
              </div>
              <div 
                className="flex items-center space-x-3 text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                onClick={handleEmailClick}
              >
                <Mail className="h-4 w-4" />
                <span>{businessInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3 text-sm text-gray-300">
                <MapPin className="h-4 w-4" />
                <span>South Australia</span>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Business Hours</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex items-center space-x-3">
                <Clock className="h-4 w-4" />
                <span>Mon - Fri: 8AM - 6PM</span>
              </div>
              <div className="ml-7">
                <p>Sat: 9AM - 4PM</p>
                <p>Sun: Closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © 2024 {businessInfo.name}. All rights reserved. Professional shutter installation services.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;